import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { GetSalesPersonList } from '../../services';
import notistack from 'modules/core/notistack';

interface SalesPersonModalProps {
    show: boolean;
    onHide: () => void;
    onSelect?: (salesPersonId: string) => void;
    selectedSalesPersonId?: string;
}

const SalesPersonModal: React.FC<SalesPersonModalProps> = ({
    show,
    onHide,
    onSelect,
    selectedSalesPersonId = '',
}) => {
    const [salesPersonList, setSalesPersonList] = useState<any[]>([]);
    const [selectedId, setSelectedId] = useState<string>(selectedSalesPersonId);

    useEffect(() => {
        if (show) {
            getAllSalesPersonList();
            setSelectedId(selectedSalesPersonId); 
        }
    }, [show, selectedSalesPersonId]);

    const getAllSalesPersonList = async () => {
        try {
            const response = await GetSalesPersonList();
            setSalesPersonList(response);
        } catch (error: any) {
            notistack.error(error.message);
        }
    };

    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const id = e.target.value;
        setSelectedId(id); 
        if (onSelect && id) {
            onSelect(id);
        }
        handleModalHide();
    };

    const handleModalHide = () => {
        onHide();
    };

    return (
        <Modal
            show={show}
            size="sm"
            onHide={handleModalHide}
            className="fade"
            dialogClassName="modal-dialog-centered"
            backdrop="static"
        >
            <Modal.Header closeButton className="border-0 pb-2">
                <div className="d-flex align-items-center">
                              <i className="bx bx-user-check me-2"></i>

                    <span className="fw-bold ">Select Sales Person</span>
                </div>
            </Modal.Header>
            <Modal.Body className="pt-0">
                <div className="mb-4">
                    <label className="form-label  small fw-semibold">
                        Sales Person <span className="text-danger">*</span>
                    </label>
                    <select
                        className="form-select"
                        onChange={handleSelect}
                        value={selectedId} 
                    >
                        <option value="">Select...</option>
                        {salesPersonList?.map((person) => (
                            <option key={person.value} value={person.value}>
                                {person.text} 
                            </option>
                        ))}
                    </select>
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <button
                        type="button"
                        className="btn add-btn btn-sm px-4"
                        onClick={handleModalHide}
                    >
                        <i className="bx bx-times me-1"></i>Cancel
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SalesPersonModal;
